<div class="instrument-error-dialog-header">
  <mat-toolbar id="dialog-titlebar" color="primary">
    <div>Instrument Error</div>
  </mat-toolbar>
</div>

<form [formGroup]="instrumentErrorForm" class="normal-form" (submit)="onSubmit()">
  <div mat-dialog-content class="instrument-error-dialog-content">
    <div class="instrument-error-controls-group">
      <mat-form-field appearance="outline" class="instrument-error-field">
        <mat-label>Instrument S/N</mat-label>
        <input matInput id="instrumentNumber" data-testid="dialog-insterror-instrumentsn-input" type="text" aria-describedby="name-error" formControlName="instrumentNumber" />
        <mat-error id="instrument-number-error" *ngIf="instrumentErrorForm.controls.instrumentNumber.errors?.required">
          This field is mandatory.
        </mat-error>
        <mat-error id="name-error" *ngIf="instrumentErrorForm.controls.instrumentNumber.errors?.maxlength">
          This field is max length 200.
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="instrument-error-field" subscriptSizing="dynamic">
        <mat-label>Known Error</mat-label>
        <mat-select
          id="known-error"
          data-testid="dialog-insterror-knownerror-select"
          [(ngModel)]="selectedIntrumentError"
          [ngModelOptions]="{standalone: true}"
          (selectionChange)="onErrorChange($event)"
          [disabled]="isLoading || !(currentRoles | hasAnyRoles : ['WRITER','READER'] : currentExperiment : 'IsAnyStatus')">
          <mat-option *ngFor="let response of errorUserResponses" [value]="response.responseId">
            {{ response.responseTitle }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline" class="instrument-error-field" subscriptSizing="dynamic">
        <mat-label>Error Text</mat-label>
        <textarea
          matInput
          id="error-text"
          data-testid="dialog-insterror-errortext-input"
          formControlName="errorText"
          maxlength="2000">
        </textarea>
      </mat-form-field>

      <div class="instrument-error-controls-group message">
        Select an option from the Known Error choices, and/or type it manually in Error Text.
      </div>
    </div>
  </div>
  <div mat-dialog-actions class="instrument-error-dialog-actions">
      <button mat-raised-button color="primary" type="button" data-testid="dialog-insterror-remove-button" *ngIf="hasError" (click)="onRemove()" [disabled]="isLoading"
      [disabled]="!(currentRoles | hasAnyRoles : ['WRITER','READER'] : currentExperiment : 'IsAnyStatus')">
        Remove Instrument Error
      </button>
      <button 
          type="button"
          *ngIf="hasError"
          color="primary"
          mat-icon-button
          class="experiment-edit-icon"
          data-testid="dialog-insterror-help-button"
          matTooltip="This option is to remove Instrument Error check and delete the info saved previously, use it only in case you had recorded an Instrument Error mistakenly.">
          <mat-icon>help</mat-icon>
        </button>
    <div class="separator"></div>
      <button mat-raised-button color="warn" type="button" data-testid="dialog-insterror-cancel-button" (click)="onCancel()" [disabled]="isLoading">Cancel</button>
      <button mat-raised-button color="primary" type="submit" data-testid="dialog-insterror-submit-button" [disabled]="instrumentErrorForm.invalid || isLoading || !(currentRoles | hasAnyRoles : ['WRITER','READER'] : currentExperiment : 'IsAnyStatus')">
        Submit
      </button>
  </div>
</form>
